import { okrDetailConstants } from './okrDetails.constants';

/** Persisted filter / URL param string values for objective status (matches GOAL_* numeric codes). */
export const ALIGNMENT_FILTER_STATUS = {
  OPEN: String(okrDetailConstants.GOAL_ACTIVE),
  CLOSED: String(okrDetailConstants.GOAL_CLOSED),
  BOTH: `${okrDetailConstants.GOAL_ACTIVE},${okrDetailConstants.GOAL_CLOSED}`,
};

/** exDate flag for time-period operator — aliases okrDetails constants. */
export const ALIGNMENT_FILTER_EX_DATE = {
  RANGE: okrDetailConstants.EX_DATE_SPAN_PERIOD,
  EXACT_DAY: okrDetailConstants.EX_DATE_EXACT_MATCH,
  ACTIVE_ON: okrDetailConstants.EX_DATE_ACTIVE_ON,
};

/** Full alignment autocomplete search item types (matches autocomplete payload `type`). */
export const ALIGNMENT_SEARCH_ITEM_TYPE = {
  USER: 'user',
  TEAM: 'team',
  GOAL: 'goal',
  CATEGORY: 'category',
};
